import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Separator } from "@/components/ui/separator";
import { Plus, Minus, AlertCircle, ShoppingCart, Pizza } from "lucide-react";
import { MenuItem, CartItem, Customization } from "@/types";
import { getMenuItemImageUrl } from "@/services/utlits";

interface FoodCustomizationModalProps {
  item: MenuItem;
  isOpen: boolean;
  onClose: () => void;
  onAddToCart: (item: CartItem) => void;
}

export function FoodCustomizationModal({
  item,
  isOpen,
  onClose,
  onAddToCart,
}: FoodCustomizationModalProps) {
  const [quantity, setQuantity] = useState(1);
  const [optionQuantities, setOptionQuantities] = useState<
    Record<string, number>
  >({});
  const [specialInstructions, setSpecialInstructions] = useState("");
  const [validationErrors, setValidationErrors] = useState<string[]>([]);

  // New props
  const [selectedOptions, setSelectedOptions] = useState<{
    [groupId: string]: { [optionId: number]: number };
  }>({});

  const handleOptionChange = (
    groupId: string | number,
    optionId: number,
    quantity: number
  ) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [groupId]: {
        [optionId]: quantity, // Replace old option with new one
      },
    }));
  };
  const handleAddonsOptionChange = (
    groupId: string | number,
    optionId: number,
    quantity: number
  ) => {
    setSelectedOptions((prev) => {
      const existingGroup = prev[groupId] || {};

      // If quantity is 0, remove the option from the group
      const updatedGroup = { ...existingGroup };
      if (quantity <= 0) {
        delete updatedGroup[optionId];
      } else {
        updatedGroup[optionId] = quantity;
      }

      return {
        ...prev,
        [groupId]: updatedGroup,
      };
    });
  };

  // Mock customization data - in real app, this would come from API

  useEffect(() => {
    let i = 0;
    // Initialize with default selections
    const defaultSelections: Record<string, Record<string, number>> = {};
    item?.mandatoryOptions?.forEach((group: any) => {
      // const defaultOptions = group.options.filter(
      //   (option: any) => option.isDefault
      // );
      i += 1;
      const defaultOptions = group;
      if (defaultOptions.length > 0) {
        defaultSelections[group.id] = {};
        defaultOptions.forEach((option: any) => {
          defaultSelections[group.id][option.id] = 1;
        });
      } else if (group.type === "required") {
        defaultSelections[group.id] = { [group.options[0].id]: 1 };
      } else {
        defaultSelections[group.id] = {};
      }
    });
    setSelectedOptions(defaultSelections);
  }, []);

  useEffect(() => {
    // Calculate total price - implementation moved to calculateTotalPrice function
  }, [selectedOptions, optionQuantities, quantity]);

  // const handleOptionChange = (
  //   groupId: string,
  //   optionId: string,
  //   newQuantity: number
  // ) => {
  //   const group = customizationGroups.find((g: any) => g.id === groupId);
  //   if (!group) return;

  //   setSelectedOptions((prev) => {
  //     const currentSelections = prev[groupId] || {};

  //     if (group.maxSelections === 1 && !group.allowQuantity) {
  //       // Radio group behavior - only one selection allowed
  //       return { ...prev, [groupId]: newQuantity > 0 ? { [optionId]: 1 } : {} };
  //     } else {
  //       // Multiple selections with quantities
  //       const newSelections = { ...currentSelections };

  //       if (newQuantity > 0) {
  //         const totalSelections = Object.keys(newSelections).length;
  //         if (
  //           !newSelections[optionId] &&
  //           totalSelections >= group.maxSelections
  //         ) {
  //           return prev; // Don't allow more selections than max
  //         }
  //         // Initialize quantity for new selection
  //         if (!optionQuantities[optionId]) {
  //           setOptionQuantities((prevQty) => ({ ...prevQty, [optionId]: 1 }));
  //         }
  //         newSelections[optionId] = newQuantity;
  //       } else {
  //         delete newSelections[optionId];
  //         // Remove quantity when deselecting
  //         setOptionQuantities((prevQty) => {
  //           const newQty = { ...prevQty };
  //           delete newQty[optionId];
  //           return newQty;
  //         });
  //       }

  //       return { ...prev, [groupId]: newSelections };
  //     }
  //   });
  // };

  const handleQuantityChange = (optionId: string, newQuantity: number) => {
    if (newQuantity >= 1 && newQuantity <= 10) {
      setOptionQuantities((prev) => ({ ...prev, [optionId]: newQuantity }));
    }
  };

  // const validateSelections = () => {
  //   const errors: string[] = [];
  //   customizationGroups.forEach((group) => {
  //     const selections = selectedOptions[group.id] || {};
  //     const selectionCount = Object.keys(selections).length;
  //     if (group.type === "required" && selectionCount < group.minSelections) {
  //       errors.push(`Please select ${group.name.toLowerCase()}`);
  //     }
  //   });
  //   setValidationErrors(errors);
  //   return errors.length === 0;
  // };

  // const handleAddToCart = () => {
  //   if (!validateSelections()) {
  //     return;
  //   }

  //   const customizations = Object.entries(selectedOptions).flatMap(
  //     ([groupId, optionQuantities]) => {
  //       const group = customizationGroups.find((g: any) => g.id === groupId);
  //       if (!group) return [];

  //       return Object.entries(optionQuantities)
  //         .map(([optionId, qty]) => {
  //           const option = group.options.find((o: any) => o.id === optionId);
  //           const quantity = optionQuantities[optionId] || 1;
  //           return option
  //             ? {
  //                 groupId,
  //                 groupName: group.name,
  //                 optionId,
  //                 price: option.price,
  //                 quantity: qty,
  //               }
  //             : null;
  //         })
  //         .filter(Boolean);
  //     }
  //   );

  //   const cartItem: CartItem = {
  //     ...item,
  //     quantity,
  //     customizations: customizations as any[],
  //     specialInstructions: specialInstructions.trim() || undefined,
  //     totalPrice: totalPrice / quantity,
  //   };

  //   onAddToCart(cartItem);
  // };

  // const isGroupValid = (groupId: string) => {
  //   const group = customizationGroups.find((g: any) => g.id === groupId);
  //   if (!group) return true;
  //   const selections = selectedOptions[groupId] || {};
  //   const selectionCount = Object.keys(selections).length;
  //   return group.type === "optional" || selectionCount >= group.minSelections;
  // };

  useEffect(() => {
    if (!isOpen || !item) return;

    const initialOptions: any = {};

    item.mandatoryOptions?.forEach((group: any) => {
      if (group.isRequired && group.options.length > 0) {
        // Set the first option with quantity 1
        initialOptions[group.id] = {
          [group.options[0].id]: 1,
        };
      }
    });

    // Optional: Also init addons with zero quantity
    const addonOptions: any = {};
    item.addons?.forEach((addon: any) => {
      addonOptions[addon.id] = 0;
    });

    // Set all selected options
    setSelectedOptions({
      ...initialOptions,
      addons: addonOptions,
    });

    setQuantity(1);
    setSpecialInstructions("");
  }, [isOpen, item]);
  const handleAddToCart = () => {
    const cartItem: CartItem = {
      ...item,
      quantity,
      totalPrice,
      customizations: formatSelectedOptionsForCart(),
      specialInstructions,
    };
    onAddToCart(cartItem);
    onClose(); // close modal after adding
  };

  // const handleAddToCart = async () => {
  //   const cartItem = {
  //     productId: item.id,
  //     name: item.name,
  //     description: item.description,
  //     basePrice: item.basePrice,
  //     discountPrice: item.discountPrice,
  //     quantity: quantity,
  //     imageUrl: item.imageUrl,
  //     selectedOptions: formatSelectedOptionsForCart(),
  //     totalPrice: totalPrice,
  //   };

  //   try {
  //     const existingCart = JSON.parse(localStorage.getItem("cart") || "[]");
  //     existingCart.push(cartItem);
  //     console.log("New Item Added", cartItem);
  //     // optionally: navigate to cart or show toast/snackbar
  //   } catch (error) {
  //     console.error("Error adding to cart:", error);
  //   }
  // };
  // const formatSelectedOptionsForCart = (): SelectedOption[] => {
  //   const formatted: SelectedOption[] = [];

  //   Object.entries(selectedOptions).forEach(([groupId, options]) => {
  //     Object.entries(options).forEach(([optionId, quantity]) => {
  //       if (quantity > 0) {
  //         const group = item.mandatoryOptions?.find(
  //           (g: any) => g.id === Number(groupId)
  //         );
  //         const option = group?.options?.find(
  //           (o: any) => o.id === Number(optionId)
  //         );

  //         if (option) {
  //           formatted.push({
  //             groupId: Number(groupId),
  //             groupName: group?.name || "",
  //             optionId: Number(optionId),
  //             optionName: option?.name,
  //             quantity,
  //             price: option?.price,
  //           });
  //         }
  //       }
  //     });
  //   });

  //   // Addons
  //   item?.addons?.forEach((addon: any) => {
  //     const quantity = selectedOptions["addons"]?.[addon.id];
  //     if (quantity > 0) {
  //       formatted.push({
  //         groupId: "addons",
  //         groupName: "Addons",
  //         optionId: addon.id,
  //         optionName: addon.name,
  //         quantity,
  //         price: addon.price,
  //       });
  //     }
  //   });

  //   return formatted;
  // };
  const formatSelectedOptionsForCart = (): Customization[] => {
    const formatted: Customization[] = [];
    Object.entries(selectedOptions).forEach(([groupId, options]) => {
      Object.entries(options).forEach(([optionId, quantity]) => {
        if (quantity > 0) {
          const group = item.mandatoryOptions?.find(
            (g: any) => g.name === groupId || g.id === Number(groupId)
          );
          const option = group?.options?.find(
            (o: any) => o.id === Number(optionId)
          );

          if (option) {
            formatted.push({
              groupId: String(groupId),
              groupName: group?.name || "",
              optionId: String(optionId),
              optionName: option?.name,
              quantity,
              price: option?.price,
            });
          }
        }
      });
    });

    // Addons (if applicable)
    item?.addons?.forEach((addon: any) => {
      const quantity = selectedOptions["addons"]?.[addon.id];
      if (quantity > 0) {
        formatted.push({
          groupId: "addons",
          groupName: "Addons",
          optionId: String(addon.id),
          optionName: addon.name,
          quantity,
          price: addon.price,
        });
      }
    });

    return formatted;
  };

  const calculateTotalPrice = (): number => {
    let base = item.basePrice;
    if (item?.discountPrice && item?.discountPrice > 0) {
      base = item.discountPrice;
    }
    // const base = item.discountPrice || item.basePrice;
    const customizations = formatSelectedOptionsForCart();

    const extrasTotal = customizations.reduce((sum, opt) => {
      return sum + opt.price * (opt.quantity || 1);
    }, 0);

    return base + extrasTotal;
  };

  const totalPrice = calculateTotalPrice();
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[95vw] max-w-2xl mx-auto p-4 sm:p-6 max-h-[90vh] overflow-hidden flex flex-col">
        <DialogHeader className="pb-3 sm:pb-4">
          <div className="flex items-start space-x-3 sm:space-x-4">
            <img
              src={getMenuItemImageUrl(item.imageUrl)}
              alt={item.imageUrl}
              className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-xl shadow-md flex-shrink-0"
            />
            <div className="flex-1 min-w-0">
              <DialogTitle className="text-lg sm:text-xl font-bold text-gray-900 font-display mb-2">
                {item.name}
              </DialogTitle>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                {item.description}
              </p>
              {/* <div className="flex items-center space-x-2 mt-2">
                <Badge className="bg-emerald-100 text-emerald-800 text-xs">
                  Base Price: ${item?.discountPrice?.toFixed(2)}
                </Badge>
              </div> */}
              <div className="flex items-center space-x-2 mt-2">
                <Badge className="bg-emerald-100 text-emerald-800 text-xs">
                  {item?.categoryName}
                </Badge>
              </div>
            </div>
          </div>
        </DialogHeader>

        {/* Validation Errors */}
        {validationErrors.length > 0 && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
            <div className="flex items-start space-x-2">
              <AlertCircle className="w-4 h-4 sm:w-5 sm:h-5 text-red-500 flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="text-sm font-semibold text-red-800 mb-1">
                  Please complete your order:
                </h4>
                <ul className="text-sm text-red-700 space-y-1">
                  {validationErrors.map((error, index) => (
                    <li key={index} className="flex items-center space-x-1">
                      <span>•</span>
                      <span>{error}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}

        <div className="flex-1 overflow-y-auto custom-scrollbar space-y-4 sm:space-y-6 pr-1 sm:pr-2">
          {item?.mandatoryOptions?.map((group: any) => {
            return (
              <div
                key={group.id}
                className={`space-y-3 p-3 sm:p-4 rounded-lg border-2 transition-all ${
                  !group?.isRequired === true
                    ? "border-red-300 bg-red-50"
                    : "border-gray-200 bg-white"
                }`}
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-gray-900 flex items-center space-x-2 text-sm sm:text-base">
                    <span>{group.name}</span>
                    {group?.isRequired === true && (
                      <Badge
                        variant={
                          group?.isRequired ? "secondary" : "destructive"
                        }
                        className="text-xs"
                      >
                        <AlertCircle className="w-3 h-3 mr-1" />
                        Required
                      </Badge>
                    )}
                  </h3>
                  <span className="text-xs text-gray-500">
                    {group.isRequired
                      ? `Choose 1`
                      : `Choose up to ${group.maxSelection}`}
                  </span>
                </div>

                <div className="space-y-2">
                  {group.maxSelection === 0 ? (
                    // Radio group for single selection without quantity
                    <div className="space-y-2">
                      {group.options.map((option: any) => (
                        <div
                          key={option.id}
                          className="flex items-center justify-between p-3 rounded-lg border border-gray-200 hover:border-emerald-300 hover:bg-emerald-50 transition-all"
                        >
                          <div className="flex items-center space-x-3 flex-1">
                            <input
                              type="radio"
                              id={`${group.id}-${option.id}`}
                              name={group.id}
                              checked={!!selectedOptions[group.id]?.[option.id]}
                              onChange={(e) =>
                                handleOptionChange(
                                  group.id,
                                  option.id,
                                  e.target.checked ? 1 : 0
                                )
                              }
                              className="w-4 h-4 text-emerald-600 border-gray-300 focus:ring-emerald-500"
                            />
                            <Label
                              htmlFor={`${group.id}-${option.id}`}
                              className="font-medium text-gray-900 cursor-pointer text-sm flex-1"
                            >
                              {option.name}
                            </Label>
                          </div>
                          {option.price > 0 && (
                            <span className="text-sm font-semibold text-emerald-600">
                              +${option?.price?.toFixed(2)}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    // Quantity selectors for multiple selections
                    <div className="space-y-2">
                      {group.options.map((option: any) => {
                        const currentQuantity =
                          selectedOptions[group.id]?.[option.id] || 0;
                        return (
                          <div
                            key={option.id}
                            className="flex items-center justify-between p-3 rounded-lg border border-gray-200 hover:border-emerald-300 hover:bg-emerald-50 transition-all"
                          >
                            <div className="flex items-center space-x-3 flex-1">
                              <Label className="font-medium text-gray-900 text-sm flex-1">
                                {option.name}
                              </Label>
                            </div>
                            <div className="flex items-center space-x-3">
                              {option?.price > 0 && (
                                <span className="text-sm font-semibold text-emerald-600">
                                  $
                                  {(
                                    option?.price * Math.max(1, currentQuantity)
                                  )?.toFixed(2)}
                                </span>
                              )}
                              <div className="flex items-center space-x-2">
                                <Button
                                  type="button"
                                  variant="outline"
                                  size="sm"
                                  onClick={() =>
                                    handleOptionChange(
                                      group.id,
                                      option.id,
                                      Math.max(0, currentQuantity - 1)
                                    )
                                  }
                                  className="h-6 w-6 p-0 border-gray-300 hover:border-emerald-500 hover:bg-emerald-50"
                                >
                                  <Minus className="w-3 h-3" />
                                </Button>
                                <span className="w-6 text-center text-sm font-bold">
                                  {currentQuantity}
                                </span>
                                <Button
                                  type="button"
                                  variant="outline"
                                  size="sm"
                                  onClick={() =>
                                    handleOptionChange(
                                      group.id,
                                      option.id,
                                      Math.min(10, currentQuantity + 1)
                                    )
                                  }
                                  className="h-6 w-6 p-0 border-gray-300 hover:border-emerald-500 hover:bg-emerald-50"
                                >
                                  <Plus className="w-3 h-3" />
                                </Button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          {/* Addons Items */}
          {(item?.addons ?? []).length > 0 && (
            <div className="space-y-3 p-3 sm:p-4 rounded-lg border-2 transition-all border-gray-200 bg-white">
              <div className="flex items-center justify-between">
                <span className="text-sm font-semibold text-gray-900">
                  Add-ons (Optional)
                </span>
                <span className="text-xs text-gray-500">Choose multiple</span>
              </div>

              <div className="space-y-2">
                {item?.addons?.map((option: any) => {
                  const currentQuantity =
                    selectedOptions["addons"]?.[option.id] || 0;

                  return (
                    <div
                      key={option.id}
                      className="flex items-center justify-between p-3 rounded-lg border border-gray-200 hover:border-emerald-300 hover:bg-emerald-50 transition-all"
                    >
                      <div className="flex items-center space-x-3 flex-1">
                        <Label className="font-medium text-gray-900 text-sm flex-1">
                          {option.name}
                        </Label>
                      </div>
                      <div className="flex items-center space-x-3">
                        {option?.price > 0 && (
                          <span className="text-sm font-semibold text-emerald-600">
                            ${option?.price.toFixed(2)}
                          </span>
                        )}
                        <div className="flex items-center space-x-2">
                          <Button
                            type="button"
                            variant="outline"
                            size="sm"
                            onClick={() =>
                              handleAddonsOptionChange(
                                "addons",
                                option.id,
                                Math.max(0, currentQuantity - 1)
                              )
                            }
                            className="h-6 w-6 p-0 border-gray-300 hover:border-emerald-500 hover:bg-emerald-50"
                          >
                            <Minus className="w-3 h-3" />
                          </Button>
                          <span className="w-6 text-center text-sm font-bold">
                            {currentQuantity}
                          </span>
                          <Button
                            type="button"
                            variant="outline"
                            size="sm"
                            onClick={() =>
                              handleAddonsOptionChange(
                                "addons",
                                option.id,
                                Math.min(10, currentQuantity + 1)
                              )
                            }
                            className="h-6 w-6 p-0 border-gray-300 hover:border-emerald-500 hover:bg-emerald-50"
                          >
                            <Plus className="w-3 h-3" />
                          </Button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Special Instructions */}
          {/* <div className="space-y-3 p-3 sm:p-4 rounded-lg border border-gray-200 bg-white">
            <h3 className="font-semibold text-gray-900 flex items-center space-x-2 text-sm sm:text-base">
              <span>Special Instructions</span>
              <Badge variant="secondary" className="text-xs">
                Optional
              </Badge>
            </h3>
            <Textarea
              placeholder="Any special requests? (e.g., 'Extra spicy', 'Mushrooms on left side only', 'No onions', 'Extra crispy')"
              value={specialInstructions}
              onChange={(e) => setSpecialInstructions(e.target.value)}
              className="min-h-[60px] sm:min-h-[80px] border-gray-200 focus:border-emerald-500 focus:ring-emerald-500 text-sm"
            />
            <div className="text-xs text-gray-500 space-y-1">
              <p>
                💡 <strong>Pro Tips:</strong>
              </p>
              <p>• "Left side mushrooms, right side peppers"</p>
              <p>• "Extra crispy" or "Well done"</p>
              <p>• "Light on sauce" or "Extra sauce on the side"</p>
            </div>
          </div> */}
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 pt-3 sm:pt-4 space-y-3 sm:space-y-4">
          {/* Quantity Selector */}
          <div className="flex items-center justify-between">
            <span className="font-semibold text-gray-900 text-sm sm:text-base">
              Quantity
            </span>
            <div className="flex items-center space-x-3">
              <Button
                variant="outline"
                size="sm"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                disabled={quantity <= 1}
                className="h-8 w-8 sm:h-10 sm:w-10 p-0 border-gray-300 hover:border-emerald-500 hover:bg-emerald-50"
              >
                <Minus className="w-3 h-3 sm:w-4 sm:h-4" />
              </Button>
              <span className="w-8 sm:w-12 text-center font-bold text-base sm:text-lg">
                {quantity}
              </span>
              <Button
                variant="outline"
                size="sm"
                onClick={() => setQuantity(quantity + 1)}
                className="h-8 w-8 sm:h-10 sm:w-10 p-0 border-gray-300 hover:border-emerald-500 hover:bg-emerald-50"
              >
                <Plus className="w-3 h-3 sm:w-4 sm:h-4" />
              </Button>
            </div>
          </div>

          {/* Add to Cart Button */}
          <Button
            onClick={handleAddToCart}
            className="w-full h-12 sm:h-14 btn-primary text-base sm:text-lg font-bold"
          >
            <ShoppingCart className="w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3" />
            Add {quantity} to Cart - ${(totalPrice * quantity)?.toFixed(2)}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
